import { makeObservable, observable, action } from 'mobx';

export type WalkingTimeType =
  | 'lessThanTwentyMin'
  | 'twentyToSixtyMinutes'
  | 'oneToTwoHours'
  | 'twoHoursPlus';

export class WalkingTimeStore {
  selectedWalkingTime: WalkingTimeType | null = null;

  constructor() {
    makeObservable(this, {
      selectedWalkingTime: observable,
      setWalkingTime: action,
    });
  }

  setWalkingTime(inputWalkingTime: WalkingTimeType) {
    this.selectedWalkingTime = inputWalkingTime;
  }
}

export const walkingTimeStore = new WalkingTimeStore();
